@if (loading()) {
  <app-loading></app-loading>
} @else {
  <nav>
    <a [routerLink]="['/']">
      <img src="assets/logo-primary.png" alt="Vodori" />
    </a>
  </nav>
  <main>
    <img src="assets/error/{{ error.img }}" [alt]="error.title" />
    <h2>{{ error.heading }}</h2>
    <p>
      {{ error.message }} <a href="mailto:support@vodori.zendesk.com">Help Desk</a>.
    </p>
    <h5>{{ error.title }}</h5>
    <section>
      @if (authenticated()) {
        <a (click)="logout()" class="button secondary">Sign out</a>
        <a [href]="backLink" class="button">Back to Vodori</a>
      } @else {
        <a *ngIf="!error.hideLogin" href="/login" target="_self" class="button">Sign in</a>
      }
    </section>
  </main>
}
